<template>
  <div class="login-page">
    <div class="container-370">
      <div class="verticle-middle w-370">
        <div class="logo-choose-role text-center">
          <img class="w-180" src="../../assets/images/parts-logo.png" alt="">
        </div>
        <div class="button-group mt-47">
          ポケットファーマシーから開きました。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {apiErrorDialog} from '@/helpers'

export default {
  methods: {
    pplogin () {
      const loading = this.$loading.show()

      try {
        this.$auth.login({
          url: `/pp/auth?token=` + this.$route.params.token,
          method: 'GET',
          data: {
            token: this.$route.params.token
          },
          fetchUser: false,
          redirect: '/pending-meetings',
          success: (res) => {
            localStorage.setItem('policy_applied', res.data.policy_applied)
            this.$auth.token(null, res.data.token)
            this.$auth.fetch()
          },
          error: (error) => {
            if (error.response && error.response.status >= 500) {
              return apiErrorDialog(this, error)
            }

            // APIレスポンスから動的にメッセージを取得
            let errorMessage = '認証できませんでした。' // フォールバック用のデフォルトメッセージ
            
            if (error.response && error.response.data) {
              const errorData = error.response.data
              
              // error_codeとmessageを取得
              const errorCode = errorData.error_code
              const message = errorData.message
              
              // アカウントロック時の特別処理
              if (errorCode === 'ACCOUNT_LOCKED' && errorData.data) {
                const remainingMinutes = errorData.data.remaining_minutes
                if (remainingMinutes && remainingMinutes > 0) {
                  errorMessage = message ? `${message} 残り時間: ${remainingMinutes}分` : `アカウントがロックされています。残り時間: ${remainingMinutes}分`
                } else {
                  errorMessage = message || 'アカウントがロックされています。'
                }
              } else if (message) {
                // 通常の認証失敗時はmessageフィールドの内容を表示
                errorMessage = message
              }
            }
            
            this.$message.error(errorMessage)
          }
        })
      } catch (e) {
        apiErrorDialog(this, e)
      }
      loading.hide()
    }
  },
  created () {
    console.log('name: ' + this.$route.name + ', token: ' + this.$route.params.token)
    this.pplogin()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/auth/PpLogin.vue